// extracted by mini-css-extract-plugin
export default {"btn":"SideSocialItem_btn__Elza8"};